<div class="input-group input-group-sm">
  @if (props.addonLeft) {
    <span
      class="input-group-text"
      [ngStyle]="{cursor: props.addonLeft.onClick ? 'pointer' : 'inherit'}"
      (click)="addonLeftClick($event)">
      @if (props.addonLeft.class) {
        <i [ngClass]="props.addonLeft.class"></i>
      }
      @if (props.addonLeft.icon) {
        <span ><fa-icon [icon]="props.addonLeft.icon"></fa-icon></span>
      }
      @if (props.addonLeft.text) {
        <span>{{ props.addonLeft.text }}</span>
      }
    </span>
  }
  <ng-template #fieldComponent></ng-template>
  @if (props.addonRight) {
    <span class="input-group-text"
      [ngStyle]="{cursor: props.addonRight.onClick ? 'pointer' : 'inherit'}"
      (click)="addonRightClick($event)">
      @if (props.addonRight.class) {
        <i [ngClass]="props.addonRight.class"></i>
      }
      @if (props.addonRight.icon) {
        <span ><fa-icon [icon]="props.addonRight.icon"></fa-icon></span>
      }
      @if (props.addonRight.text) {
        <span>{{ props.addonRight.text  }}</span>
      }
    </span>
  }
</div>
